module.exports = __webpack_public_path__ + "media/images/flags/32/Luxembourg-4e1ecd7ef47935f9e5e7ac314fa2337d.png";